import { defineComponent as _defineComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

window.location.replace("http://vehaontzorgt.nl")

return () => {}
}

})